(() => {
  // Set the height of the container based on the image aspect ratio
  setContainerHeight();
  window.addEventListener("resize", setContainerHeight);
  // for collection slider
  carouselElement();
  // Updates hours of operation status
  updateStoreStatus({
    open: 9,
    close: 17,
    textContainer: document.getElementById("store-status"),
  });

  // FUNCTIONS
  function setContainerHeight() {
    const containers = document.querySelectorAll(".autoheight");

    containers.forEach((container) => {
      const image = container.querySelector("img");

      if (image) {
        const width = container.offsetWidth;
        const ratio = image.naturalHeight / image.naturalWidth;
        const height = width * ratio;

        container.style.height = `${height}px`;
      }
    });
  }
  window.addEventListener("resize", setContainerHeight);

  /**
   * Updates the store status based on the current time.
   * @param {Object} options - The options for updating the store status.
   * @param {number} options.open - The opening hour of the store.
   * @param {number} options.close - The closing hour of the store.
   * @param {HTMLElement} options.textContainer - The container element to display the store status.
   */
  function updateStoreStatus({ open, close, textContainer }) {
    if (!textContainer) return;
    function toPST(date) {
      const utc = date.getTime() + date.getTimezoneOffset() * 60000;
      return new Date(utc - 3600000 * 8);
    }

    const now = toPST(new Date());
    const day = now.getDay();
    const hours = now.getHours();

    if (day >= 1 && day <= 5) {
      if (hours < open) {
        textContainer.innerHTML =
          "Customer service is currently closed. Opens at 9:00 AM.";
      } else if (hours >= close) {
        textContainer.innerHTML =
          "Customer service is currently closed. Opens tomorrow at 9:00 AM.";
      } else {
        textContainer.innerHTML = "Customer service is currently open.";
      }
    } else {
      textContainer.innerHTML = "Customer service is closed today.";
    }
  }

  /* eslint-env browser */

  function carouselElement() {
    const slider = document.querySelector(".tws__slider");
    if (!slider) return;
    const slide = slider.querySelector(".tws__slide-list");
    const next = slider.querySelector(".pro-next");
    const prev = slider.querySelector(".pro-prev");
    const need_loop = document.querySelector(".tws__ctrl").hasAttribute("data-loop");
    const itemsWidth = 690;
    const itemsPerStep = 1;

    let currentSlide = 0;
    let totalSlides = slide.children.length;
    let totalItems = slide.children.length;

    function updateSlider() {
      slide.style.transform = `translateX(-${currentSlide * itemsWidth}px)`;

      // if not need loop, will hidden next and prev buttion when match condition
      if (!need_loop) {
        // Hide next button if in the last slide
        if (currentSlide === totalSlides - itemsPerStep) {
          next.style.display = "none";
        } else {
          next.style.display = "block";
        }
        // Hide prev button if in the first slide
        if (currentSlide === 0) {
          prev.style.display = "none";
        } else {
          prev.style.display = "block";
        }
      }
    }

    function nextSlide() {
      currentSlide += itemsPerStep;
      if (currentSlide > totalSlides - itemsPerStep) {
        if (need_loop) {
          currentSlide = 0;
        } else {
          currentSlide = totalSlides - itemsPerStep;
        }
      }

      updateSlider();
    }

    function prevSlide() {
      currentSlide -= itemsPerStep;
      if (currentSlide < 0) {
        if (need_loop){
          currentSlide = totalSlides - itemsPerStep;
        } else {
          currentSlide = 0;
        }
      }

      updateSlider();
    }

    next.addEventListener("click", nextSlide);
    prev.addEventListener("click", prevSlide);

    window.addEventListener("resize", () => {
      totalSlides = Math.ceil(totalItems / itemsPerStep);
      updateSlider();
    });

    updateSlider();
  }
  const imageOvrelayBtn = document.querySelectorAll(
    ".img-wrp .svg-wrp .imageOvrelaybtn"
  );
  if (imageOvrelayBtn != null) {
    // const imageOvrelayText = document.querySelectorAll('.img-wrp .image-ovrelayContent');
    imageOvrelayBtn.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        const imageOvrelayText = button.closest(".img-wrp");
        // button.classList.remove("is--active");
        if (button.classList.contains("is--active")) {
          button.classList.remove("is--active");
          imageOvrelayText
            .querySelector(".image-ovrelayContent")
            .classList.remove("is--active");
        } else {
          // imageOvrelayBtn.classList.remove("is--active");
          button.classList.add("is--active");
          imageOvrelayText
            .querySelector(".image-ovrelayContent")
            .classList.add("is--active");
        }
      });
    });
  }
})();
